import React from 'react';

/**
 * Visual fallback for React.Suspense while lazy-loaded chunks download.
 * Minimal, brand-consistent (KOMPA yellow), no layout shift vs. a full page.
 * Kept dependency-free to stay in the main bundle.
 */
export default function LoadingFallback({ label = 'Cargando…' }) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-white"
      data-testid="loading-fallback"
      role="status"
      aria-live="polite"
    >
      <div className="relative w-12 h-12">
        <div className="absolute inset-0 rounded-full border-4 border-gray-100" />
        <div className="absolute inset-0 rounded-full border-4 border-[#fbb040] border-t-transparent animate-spin" />
      </div>
      <p className="mt-4 text-xs font-medium text-gray-400 uppercase tracking-widest">{label}</p>
    </div>
  );
}
